// extracted by mini-css-extract-plugin
export default {"content":"EG-z","lookName":"FG-z","shopTheLookContainer":"GG-z","productContainer":"HG-z","imageContainer":"IG-z","mainImage":"JG-z"};